import { jsx as _jsx } from "react/jsx-runtime";
import pearDarkBlueUrl from '../../../assets/gems/pear_dark_blue.svg?inline';
export function PearDarkBlue({ ...props }) {
    return _jsx("img", { ...props, src: pearDarkBlueUrl, alt: 'PearDarkBlueImage' });
}
